import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/components/alert-dialog/alert-dialog.component';
import { AdvancedSearchOptions } from 'src/app/models/';
import { DEFAULT_CUSTOMER_SEARCH_OPTIONS } from 'src/app/constants/constants';

@Injectable({
  providedIn: 'root'
})
export class CustomerSearchOptionsService
{

  public readonly defaultSearchOptions: AdvancedSearchOptions = DEFAULT_CUSTOMER_SEARCH_OPTIONS;


  constructor(private dialog: MatDialog) { }

  validateSearchOptions(customerSearchOptions: AdvancedSearchOptions): boolean
  {

    let trueCount = 0;
    for (const property in customerSearchOptions)
    {
      if (customerSearchOptions.hasOwnProperty(property) && customerSearchOptions[property] === true)
      {
        trueCount++;
      }
    }

    const onlyInactiveAndOrTempActive =
      (customerSearchOptions.IncludeInactive && trueCount === 1) ||
      (customerSearchOptions.IncludeTempCustomers && trueCount === 1) ||
      (customerSearchOptions.IncludeInactive && customerSearchOptions.IncludeTempCustomers && trueCount === 2);

    if (onlyInactiveAndOrTempActive)
    {
      return false;
    }

    for (const property in customerSearchOptions)
    {
      if (customerSearchOptions.hasOwnProperty(property))
      {
        const value = customerSearchOptions[property];
        if (typeof value === 'boolean' && value)
        {
          return true;
        }
      }
    }
    return false;
  }

  showAlertDialog(): void
  {
    this.dialog.open(AlertDialogComponent, {
      panelClass: 'alert-dialog',
      width: "400px",
      height: "200px",
      disableClose: true,
      data: {
        title: "Invalid Search Options",
        message: "Please select at least one search option to filter the customers.",
        buttonText: "Close"
      }
    });
  }

  cloneDefaultCustomerSearchOptions(): AdvancedSearchOptions
  {
    return JSON.parse(JSON.stringify(DEFAULT_CUSTOMER_SEARCH_OPTIONS));
  }

  setCustomerSearchOptionsToDefault(): AdvancedSearchOptions
  {
    const defaultSearchOptions = this.cloneDefaultCustomerSearchOptions();
    return defaultSearchOptions;
  }

  checkIfDefaultCustomerSearch(customerSearchOptions: AdvancedSearchOptions): boolean
  {
    const defaultOptions = this.defaultSearchOptions;

    return (
      customerSearchOptions.CustomerCustId === defaultOptions.CustomerCustId &&
      customerSearchOptions.CustomerAccountNo === defaultOptions.CustomerAccountNo &&
      customerSearchOptions.CustomerName === defaultOptions.CustomerName &&
      customerSearchOptions.CustomerAddress === defaultOptions.CustomerAddress &&
      customerSearchOptions.CustomerEmail === defaultOptions.CustomerEmail &&
      customerSearchOptions.CustomerPhone === defaultOptions.CustomerPhone &&
      customerSearchOptions.LocName === defaultOptions.LocName &&
      customerSearchOptions.LocAddress === defaultOptions.LocAddress &&
      customerSearchOptions.IncludeInactive === defaultOptions.IncludeInactive &&
      customerSearchOptions.IncludeTempCustomers === defaultOptions.IncludeTempCustomers
    );
  }

}